import React, {FunctionComponent, Fragment} from 'react'
import Select from '../../../ui/Select';

interface ISelectControl {
    label?: string;
    value?: string;
    placeholder?: string;
    name: string;
    onChange: (k: any, v: string) => void;
    className: string;
}

const SelectControl: FunctionComponent<ISelectControl> = (props) => {
    const {label, value, placeholder, name, onChange, className} = props;

    return (
        <Fragment>
            { label && <label className="col-xs-2 control-label text-left text-nowrap">{label}:</label>}
            <div className={className}>
                <Select
                    matcher={true}
                    value={value}
                    className="select form-control"
                    placeholder={placeholder ? placeholder : ''}
                    name={name}
                    onChange={onChange}
                >
                    {props.children}
                </Select>
            </div>
        </Fragment>
    )
};

export default SelectControl
